import { Service } from "@ali/abf-base";
import { offlineUser, hostMap } from './exportUtil'

function requestCtrl(data) {
  if (!data) {
    throw new Error("系统繁忙，请稍后再试");
  }
  if (data.status === -2) {
    throw new Error('未登录');
  } else if (data.status === -7) {
    offlineUser()
  } else if (data.status !== 0) {
    throw new Error(data.msg ? `${data.msg}[${data.status}]` : `系统繁忙，请稍后再试${data.status ? `[${data.status}]` : ''}`);
  }
  return data
}
class VMSService extends Service {
  constructor() {
    super(hostMap);
  }

  get(api, param, extend?: any, timeout?: any) {
    return super.get(api, param, 'straight', timeout).then((data) => {
      return requestCtrl(data)
    });
  }

  post(api, param, extend?: any, timeout?: any) {
    return super.post(api, param, 'straight', timeout).then((data) => {
      return requestCtrl(data)
    });
  }

  aclCheck(authCode: string[]): Promise<any> {
    return this.get('/api/common/aclCheck', {
      authCode: authCode.join(',')
    });
  }

  getAccountStatus(): Promise<any> {
    return this.get('/api/account/status', {});
  }

  signedAgreement(): Promise<any> {
    return this.post('/api/account/signedAgreement', {});
  }

  getFansAnalyse(cid: string): Promise<any> {
    return this.get('/api/person/audienceAnalyse', {
      cid
    });
  }

  getEndorsementList(cids: string[]): Promise<any> {
    if (!cids || !cids.length) {
      return Promise.resolve({
        data: [],
      });
    }
    return this.get("/api/person/endorsement", {
      cid: cids.join(","),
    });
  }

  postExportData(param: any): Promise<any> {
    return this.post("/api/v2/report/data", param, undefined, 10000000);
  }

  postExport(param: any): Promise<any> {
    return this.post("/api/v2/report/export", param, undefined, 10000000);
  }

  searchList(name: string): Promise<any> {
    return this.get('/api/index/search', {
      name
    });
  }
}

const vmsService = new VMSService();
export default vmsService;
